/**
 * Sticky Navbar Module
 * File: sticky-navbar.js
 * Description: Questo modulo gestisce la logica della sticky navbar, attivandola solo quando raggiunge il top della finestra.
 *
 */

const StickyNavbar = {
  navbar: null,
  adminBar: null,
  navbarHeight: 0,
  adminBarHeight: 0,
  isSticky: false,
  triggerOffsetTop: 0,

  // Inizializza la navbar sticky con ID dinamico e opzionale adminBar
  initialize(navbarId, adminBarId = "wpadminbar") {
    this.navbar = document.getElementById(navbarId);
    this.adminBar = adminBarId ? document.getElementById(adminBarId) : null;

    if (!this.navbar) {
      console.warn(`Navbar con ID "${navbarId}" non trovato.`);
      return;
    }

    // Calcola l'altezza della navbar e admin bar
    this.navbarHeight = this.navbar.offsetHeight;
    this.adminBarHeight = this.adminBar ? this.adminBar.offsetHeight : 0;
    console.log("Altezza navbar → ", this.navbar.offsetHeight + "px");

    // Calcola la distanza dal top del documento
    this.triggerOffsetTop =
      this.navbar.getBoundingClientRect().top + window.scrollY;

    this.attachScrollListener();
    this.attachResizeListener();
  },

  // Aggiorna il padding-top del body SOLO quando la navbar diventa sticky
  updateBodyPadding(applyPadding) {
    const totalPadding = applyPadding ? this.navbarHeight : 0;
    document.body.style.paddingTop = `${totalPadding}px`;
  },

  // Imposta la posizione top della navbar in base all'admin bar
  adjustNavbarPosition(applyOffset) {
    const offset = applyOffset ? this.adminBarHeight : 0;
    this.navbar.style.top = `${offset}px`;
  },

  // Aggiunge o rimuove la classe sticky in base allo scroll
  handleScroll() {
    const currentScrollPosition = window.scrollY;

    if (currentScrollPosition >= this.triggerOffsetTop && !this.isSticky) {
      this.navbar.classList.add("sticky-navbar");
      this.adjustNavbarPosition(true); // Applica offset per admin bar
      this.updateBodyPadding(true); // Applica padding quando sticky
      this.isSticky = true;
    } else if (currentScrollPosition < this.triggerOffsetTop && this.isSticky) {
      this.navbar.classList.remove("sticky-navbar");
      this.adjustNavbarPosition(false); // Rimuove offset
      this.updateBodyPadding(false); // Rimuove il padding
      this.isSticky = false;
    }
  },

  // Listener per lo scroll
  attachScrollListener() {
    window.addEventListener("scroll", () => this.handleScroll());
  },

  // Listener per il resize (aggiorna altezze e trigger)
  attachResizeListener() {
    window.addEventListener("resize", () => {
      this.navbarHeight = this.navbar.offsetHeight;
      this.adminBarHeight = this.adminBar ? this.adminBar.offsetHeight : 0;
      this.triggerOffsetTop =
        this.navbar.getBoundingClientRect().top + window.scrollY;

      if (this.isSticky) {
        this.updateBodyPadding(true);
        this.adjustNavbarPosition(true);
      }
    });
  },
};

export default StickyNavbar;
